import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";
import MDBox from "shared/components/MDBox";
import HeaderLoteFinanciera from "./components/HeaderLoteFinanciera";

const GestionFinancieraDetalle = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <MDBox mt={2} mb={0}>
        <HeaderLoteFinanciera refreshFlag={refreshFlag} />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default GestionFinancieraDetalle;
